import {BaseQueryApi} from "@reduxjs/toolkit/query";
import {store, storeExtra} from "./store";
import {OtsAsyncThunkConfigExtra} from "@ots-frontend/ots-data";

const abortController = new AbortController()

export const baseQueryApi: BaseQueryApi = {
  signal: abortController.signal,
  abort: (reason) => abortController.abort(reason),
  dispatch: store.dispatch,
  getState: store.getState,
  extra: storeExtra,
  type: 'query',
  endpoint: '/',
}

export const getBaseUrl = (): string => {
  return (baseQueryApi.extra as OtsAsyncThunkConfigExtra).baseUrl
}

export const buildUrl = (path: string) : string => {
  const baseUrl = getBaseUrl()
  return `${baseUrl}${path}`
}
